import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

interface Props {
  firstTitle: string;
  secondTitle: string;
  thirdTitle: string;
  onClick?: () => void;
  isDirty?: boolean;
}

export const DesktopThreeStepNavigation = (props: Props) => {
  const { firstTitle, secondTitle, thirdTitle } = props;
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", cursor: "pointer" }}>
      <Typography variant="h5" color={"primary.main"} onClick={() => (props.isDirty && props.onClick ? props.onClick() : navigate(-2))}>
        {firstTitle}
      </Typography>
      <IconButton sx={{ p: 0 }}>
        <KeyboardArrowRightIcon />
      </IconButton>
      <Typography variant="h5" color={"primary.main"} sx={{ pl: 0.5 }} onClick={() => (props.isDirty && props.onClick ? props.onClick() : navigate(-1))}>
        {secondTitle}
      </Typography>
      <IconButton sx={{ p: 0 }}>
        <KeyboardArrowRightIcon />
      </IconButton>
      <Typography variant="h5" color={"secondary.main"} sx={{ pl: 0.5 }}>
        {thirdTitle}
      </Typography>
    </Box>
  );
};
